const de = {
    splash: {
        start: {
            helper: 'Drücken Sie die Taste, um anzufangen.',
            button: 'Start Bestellung'
        },
        banner: {
            title: 'Willkommen im {ORGANISATION}!',
            content: 'An diesem Selbstbedienungskiosk können Sie ganz einfach Ihre Eintrittskarte(n) bestellen.'
        }
    },
    catalog: {
        loading: 'Wird geladen...',
        tabs: {
            ongoing: 'Aktuelle',
            all: 'Alles'
        },
        items: {
            select: 'Selektieren',
            empty: 'Keine anstehenden Events!!'
        }
    },
    cart: {
        title: 'Mein Reservierung',
        empty: 'Noch keine Tickets im Warenkorb',
        items: {
            tickets: 'Tickets',
            date: 'Datum',
            time: 'Zeit'
        },
        total: 'Gesammtbetrag',
        buttons: {
            checkout: 'Bezahlen',
            cancel: 'Annulieren'
        }
    },
    booking: {
        steps: {
            quantity: {
                title: 'Ticket Anzahl'
            },
            upsell: {
                title: 'Ergänzungen für deine Bestellung'
            },
            plot: {
                title: 'Reservierung',
                empty: 'Es sind keine Buchungsmomente verfügbar.',
                now: 'Sie haben den Buchungszeitpunkt gewählt, um jetzt Eintritt zu erhalten.',
                change: 'Ändern'
            }
        },
        buttons: {
            continue: 'Weiter',
            return: 'Zurück',
            cancel: 'Annulieren'
        }
    },
    checkout: {
        loading: 'Wird geladen...',
        steps: {
            payment: 'Bitte Bezahlen Sie auf der EC-terminal...',
            acts: {
                payment: 'Schließen Sie die Zahlung per Karte oder Barzahlung ab...',
                paymentLeft: 'Sie müssen noch {paymentLeft} zahlen',
                cancel: 'Abbrechen',
            },
            tickets: 'Bezahlen erfolgt, Bitte Tickets mitnehmen...',
            tickets_info: 'Möchten Sie ein Beleg bekommen?',
            receipt: 'Bitte Beleg  mitnehmen..',
            receipt_info: 'Ihr Beleg ist gedrückt worden.',
            failures: {
                transaction: {
                    title: 'Die Zahlung war nicht erfolgreich!',
                    description: 'Bitte versuchen Sie die Transaktion nochmal zu Zahlen'
                },
                print: {
                    title: 'Tickets und Beleg können nicht Gedruckt worden.',
                    description: 'Bitte fragen sie ein Mitarbeiter für assistenz'
                }
            },
            error: 'Bestellung wurde nicht erfolgreich aufgegeben!'
        },
        buttons: {
            retry: 'Neu versuchen Bitte',
            cancel: 'Zurück',
            next: 'nächsten Kunden',
            yes: 'Ja',
            yes_info: 'Ich möchte ein Beleg',
            no: 'Nein',
            no_info: 'Kein Beleg nötig!',
            reprint_tickets: 'Tickets erneut drucken',
            reprint_tickets_countdown: 'Tickets erneut drucken ({seconds}s)'
        }
    },
    errors: {
        audience_not_found: 'Die Zielgruppe wurde nicht gefunden.',
        captcha_invalid: 'Das CAPTCHA ist ungültig, bitte laden Sie die Seite neu und bestellen Sie erneut.',
        coupon_expired: 'Dieser Gutschein ist abgelaufen.',
        coupon_invalid: 'Der angegebene Gutscheincode ist ungültig.',
        coupon_product_mismatch: 'Dieser Gutschein kann nicht für dieses Produkt verwendet werden.',
        coupon_redemptions_exceeded: 'Dieser Gutschein wurde vollständig verwendet.',
        customer_field_invalid: 'Ein Formularfeld ist falsch ausgefüllt, überprüfen Sie Ihre Angaben.',
        customer_field_missing: 'Ein Formularfeld fehlt, überprüfen Sie Ihre Angaben.',
        customer_token_invalid: 'Kundenschlüssel ist ungültig, bitte melden Sie sich erneut an.',
        customer_token_required: 'Diese E-Mail-Adresse ist bereits registriert, bitte melden Sie sich an, bevor Sie eine Bestellung aufgeben.',
        plot_capacity_insufficient: 'Der Buchmoment, den Sie bestellen möchten, hat keine Kapazität mehr, bitte wählen Sie einen anderen Moment aus.',
        plot_not_found: 'Der Buchmoment, den Sie bestellen möchten, ist nicht mehr verfügbar.',
        product_max_quantity_exceeded: 'Die Anzahl der Tickets liegt über dem maximalen Kauf, bitte verringern Sie Ihre Anzahl.',
        product_min_quantity_exceeded: 'Die Anzahl der Tickets liegt unter der Mindestbestellmenge, erhöhen Sie Ihre Anzahl.',
        product_not_found: 'Das Produkt, das Sie bestellen möchten, ist nicht mehr verfügbar.',
        rebook_invalid: 'Die Umbuchung ist nicht gültig.',
        rebook_product_mismatch: 'Die Umbuchung kann nicht mit dem angegebenen Produkt erfolgen.',
        subscription_expired: 'Das Abonnement ist abgelaufen.',
        subscription_inactive: 'Das Abonnement ist nicht mehr aktiv, die Kapazität reicht wahrscheinlich nicht aus.',
        subscription_invalid: 'Das Abonnement ist ungültig.',
        subscription_not_found: 'Das angegebene Abonnement kann nicht gefunden werden.',
        subscription_product_mismatch: 'Das Abonnement gewährt keinen Zugriff auf dieses Produkt.',
        subscription_quantity_mismatch: 'Das Abonnement gewährt keinen Zugriff auf diese Nummern.',
        subscription_redemptions_exceeded: 'Das Abonnement hat seine maximale Nutzung überschritten.',
        subscription_used_today: 'Das Abonnement wurde heute bereits verwendet.',
        upsell_not_allowed: 'Dieses Upsell kann nicht in Kombination mit diesem Produkt bestellt werden.',
        upsell_not_found: 'Der Upselling wurde nicht gefunden.'
    },
    printer: {
        title: 'Beim Drucker ist ein Fehler aufgetreten!',
        reload: 'Bitte neu Versuchen',
        errors: {
            paper_empty: 'Das Papier ist fast aus.',
            cover_open: 'Die Deckel ist geöffnet.',
            device_offline: 'Es konnte keine Verbindung erstellt worden.',
            device_malfunction: 'Eine allgemeiner Fehler ist vorgefallen.'
        }
    }
}

export default de;
